import LibraryEditor from './LibraryEditor';

export default function LandingPageUrlsTab({ canWrite }: { canWrite: boolean }) {
  return <LibraryEditor type="landing_page_url" canWrite={canWrite} perProduct />;
}
